import { useResource } from 'datx-jsonapi-react';
import { FC, useEffect } from 'react';
import { useLocalStorage } from 'react-use';

import { VIEW_TYPE_KEY, ViewType } from '@/components/ui/features/schedule/static';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useUserEventTimezone } from '@/hooks/useUserEventTimezone';
import { queryThinEvent } from '@/queries/thin-events';

export const TimeZoneInit: FC<{ eventId: string }> = ({ eventId }) => {
  const { timeZone, change, active_tab, view_type } = useQueryParams<{
    timeZone: string;
    view_type: ViewType;
    active_tab: string;
  }>({
    timeZone: StringParam,
    active_tab: StringParam,
    view_type: StringParam,
  });

  const [viewTypeLocal] = useLocalStorage(VIEW_TYPE_KEY, ViewType.CALENDAR);

  const { data: event } = useResource(queryThinEvent(eventId));
  const userEventTimezone = useUserEventTimezone(eventId);

  useEffect(() => {
    const calcViewType = view_type || viewTypeLocal;

    change({ timeZone: userEventTimezone, active_tab, view_type: calcViewType }, { method: 'replace', shallow: true });
  }, [active_tab, change, event.timeZone, timeZone, userEventTimezone, viewTypeLocal, view_type]);

  return null;
};
